var BaseView = require('../../../components/accordion-list/content');
var ColorThumbnailView = require('../../../components/thumbnail/color');
var AnalyticsDecorate = require('../../../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('../../analytics/backgrounds'), BaseView.extend({
  apiCall: 'search/backgrounds',
  dataName: 'backgroundCategories',
  callbackName: 'callbackImages',
  where: {},

  initialize: function (options) {
    this.category = _.find(INKIVE.Tool._cache['backgroundCategories'], function (category) {
      return category.id == options.key;
    });

    BaseView.prototype.initialize.call(this, options);
  },

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: { category: this.category.name }
    };

    this.from += this.limit;

    return params;
  },

  extractData: function (data) {
    return _.map(data, function (item) {
      var imageData = this.getImageData(item);
      this.imagesFactory.addImageData(imageData);

      return {
        id: 'background-' + item['id'],
        src: imageData.version.thumb,
        cls: parseInt(item['active']) ? '' : ' grayscale',
        data: imageData,
        width: 125,
        height: 78
      };
    }, this);
  },

  getImageData: function (item) {
    return {
      name: item['readable_name'],
      count: item['count'],
      version: {
        original: item['url'],
        largeweb: item['url'],
        web: item['url'],
        tab: item['url'],
        mobile: item['url'] && item['url'].replace('-web', '-mobile'),
        thumb: item['url'] && item['url'].replace('-web', '-thumb')
      }
    };
  },

  getScrollHeight: function ($target) {
    return $target.closest('.tab-content').height() - this.$el.siblings().height();
  },

  render: function () {
    this.$el.html(this.template({
      placeholder: this.filterPlaceholder,
      colors: true
    }));

    this.$el.find('.antiscroll-inner').addThumb();
    this.renderColors();
  },

  renderColors: function () {
    var $addMore = this.$el.find('.colorLineWrapper .addmore');
    _.each(this.tool.editor.getFavColors(), this.addColorThumb, this);
    this.initColorPicker();
  },

  addColorThumb: function (color) {
    var $view = $('<div class="palette-item">');
    var colorThumbnail = new ColorThumbnailView({
      el: $view,
      color: color
    });

    $view.insertBefore(this.$el.find('.colorLineWrapper .addmore'));
  },

  initColorPicker: function () {
    var $newcolor;
    var $wrapper = this.$el.find('.colorLineWrapper');

    $wrapper.find('.addmore').colorpicker({
      defaultColor: '#FFFFFF',
      onSubmit: _.bind(function (color, context) {
        this.addColorThumb(color);
      }, this)
    });
  }
}));
